<template>

    <div class="container">

        <div class="carousel">

            <div class="side" v-show="isDesktop" @click="previous">
                <img src="/img/help/chevron-left.svg">
            </div>

            <div class="card" ref="card1" v-show="desktop1">
                <mardown :text="$t('help_auto_delete')" class="text-baseRegular color__white"></mardown>
                <img src="/img/help/actions/auto-delete.svg" class="image">
            </div>

            <div class="card" ref="card2" v-show="desktop2">
                <mardown :text="$t('help_delete')" class="text-baseRegular color__white"></mardown>
                <img src="/img/help/actions/delete.svg" class="image">
            </div>

            <div class="card" ref="card3" v-show="desktop3">
                <mardown :text="$t('slide_down_later_receive')" class="text-baseRegular color__white"></mardown>
                <img src="/img/help/actions/sort-later.svg" class="image">
            </div>

            <div class="card" ref="card4" v-show="desktop4">
                <mardown :text="$t('help_keep')" class="text-baseRegular color__white"></mardown>
                <img src="/img/help/actions/keep.svg" class="image">
            </div>

            <div class="side" v-show="isDesktop" @click="next">
                <img src="/img/help/chevron-right.svg">
            </div>
        </div>

        <img :src="computedTags" class="tags">


    </div>

</template>

<script>

import Mardown from '../../components/Markdown'

export default {

    name: 'help-carousel',

    components: {
        Mardown
    },

    computed: {
        computedTags() {
            if(this.isTopCard2) {
                return '/img/help/actions/tabs-1.svg'
            } else if (this.isTopCard3) {
                return '/img/help/actions/tabs-2.svg'
            } else if (this.isTopCard4) {
                return '/img/help/actions/tabs-3.svg'
            } else {
                return '/img/help/actions/tabs-0.svg'
            }
        },

        isTopCard2() {
            return this.tipsVisibility.card2 > this.tipsVisibility.card1
                && this.tipsVisibility.card2 > this.tipsVisibility.card3
                && this.tipsVisibility.card2 > this.tipsVisibility.card4
        },

        isTopCard3() {
            return this.tipsVisibility.card3 > this.tipsVisibility.card1
                && this.tipsVisibility.card3 > this.tipsVisibility.card2
                && this.tipsVisibility.card3 > this.tipsVisibility.card4
        },

        isTopCard4() {
            return this.tipsVisibility.card4 > this.tipsVisibility.card1
                && this.tipsVisibility.card4 > this.tipsVisibility.card2
                && this.tipsVisibility.card4 > this.tipsVisibility.card3
        },

        desktop1() {
            return this.isDesktop
                ? this.desktopIndex%4 === 0
                : true
        },

        desktop2() {
            return this.isDesktop
                ? this.desktopIndex%4 === 1
                : true
        },

        desktop3() {
            return this.isDesktop
                ? this.desktopIndex%4 === 2
                : true
        },

        desktop4() {
            return this.isDesktop
                ? this.desktopIndex%4 === 3
                : true
        }
    },

    data() {
        return {
            tipsVisibility: {
                card1: 0,
                card2: 0,
                card3: 0,
                card4: 0
            },
            tipsObersever: {
                card1: null,
                card2: null,
                card3: null,
                card4: null
            },
            desktopIndex: 4000
        }
    },

    mounted() {
        this.cardsObserver()
    },

    methods: {

        cardsObserver() {
            this.createOberserver('card1')
            this.createOberserver('card2')
            this.createOberserver('card3')
            this.createOberserver('card4')
        },

        createOberserver(name) {
            const imageElement = this.$refs[name]
            this.tipsObersever[name] = new IntersectionObserver(
                (entries) => {
                    const entry = entries[0]
                    this.tipsVisibility[name] = Math.round(entry.intersectionRatio * 100)
                },
                {
                    threshold: Array.from({ length: 101 }, (_, i) => i / 100) // visibility percentage
                }
            )
            this.tipsObersever[name].observe(imageElement)
        },

        destroyObersever(observer) {
            if (this.tipsObersever[observer]) {
                this.tipsObersever[observer].disconnect()
            }
        },

        previous() {
            this.desktopIndex --
        },

        next() {
            this.desktopIndex ++
        }
    },

    beforeDestroy() {
        this.destroyObersever('card1')
        this.destroyObersever('card2')
        this.destroyObersever('card3')
        this.destroyObersever('card4')
    }
}

</script>

<style scoped lang="scss">

.container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-bottom: 20px;

    .carousel {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr;
        grid-template-rows: 1fr;
        gap: 0px 8px;
        grid-template-areas:
    ". . . .";
        overflow-x: scroll;
        padding: 0 16px;

        -ms-overflow-style: none;  /* IE and Edge */
        scrollbar-width: none;  /* Firefox */

        &::-webkit-scrollbar {
            display: none;
        }

        @media screen and (min-width: $above-tablet-length) {
            display: flex;
            flex-direction: row;
            padding: 0;
            gap: 0;
        }

        .card {
            flex: 1;
            padding: 24px 16px;
            border-radius: 16px;
            background: linear-gradient(155deg, #198FAC 0%, #1F497D 100%);
            display: flex;
            flex-direction: column;
            text-align: center;
            justify-content: space-between;

            > image {
                margin-top: 20px;

                @media screen and (min-width: $above-tablet-length) {
                    width: fit-content;
                }
            }

            @media screen and (min-width: $above-tablet-length) {
                width: 100%;
                max-width: 332px;
                align-items: center;
            }
        }

        .side {
            width: 84px;
            display: flex;
            align-items: center;
            justify-content: center;

            > img {
                width: 36px;
                object-fit: contain;
                padding: 8px;
                border: 1px solid $platinum;
                border-radius: 30px;
                cursor: pointer;
            }
        }
    }


    .tags {
        height: 10px;
        object-fit: contain;
        margin-top: 16px;
    }
}

</style>